import { render, staticRenderFns } from "./ContactSection.vue?vue&type=template&id=9b550062&scoped=true"
import script from "./ContactSection.vue?vue&type=script&lang=js"
export * from "./ContactSection.vue?vue&type=script&lang=js"
import style0 from "./ContactSection.vue?vue&type=style&index=0&id=9b550062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b550062",
  null
  
)

export default component.exports